module.exports = __webpack_public_path__ + "img/phon2-jn.2ba55536.png";